import { render, staticRenderFns } from "./VivoEmPauta.vue?vue&type=template&id=848ae0d6&scoped=true&"
import script from "./VivoEmPauta.vue?vue&type=script&lang=js&"
export * from "./VivoEmPauta.vue?vue&type=script&lang=js&"
import style0 from "./VivoEmPauta.vue?vue&type=style&index=0&id=848ae0d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848ae0d6",
  null
  
)

export default component.exports